module.exports = require("core-js/library/fn/weak-map");


// WEBPACK FOOTER //
// ../node_modules/@babel/runtime-corejs2/core-js/weak-map.js